import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import * as Highcharts from 'highcharts';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {CustomerService, DashboardService, RootService} from '../../services';

declare var $: any;

// @ts-ignore
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit, OnDestroy {
  loadingChart = false;
  unsubscribe$ = new Subject<void>();
  tabValue;
  socket: any;
  listRealtime = [];
  pageSize = 8;
  pageIndex = 1;
  disconnectIo = true;
  action = 'scan';
  dateRange = [];
  dataTimeLine = [];
  categoryLine = [];
  timeLabel;
  startTime;
  customers;
  endTime;
  dataTimePie = [];
  queryChartLine;
  isVisible = false;
  // statusPhone = false;
  actions = [
    {
      label: 'Lượt xem sản phẩm',
      value: 'view',
    },
    {
      label: 'Scan',
      value: 'scan',
    },
    {
      label: 'Đánh giá',
      value: 'review',
    },
    {
      label: 'Hỏi đáp',
      value: 'question',
    },
  ];
  bg = 0;
  summary;
  loading = true;
  listSupcription;
  actionText = 'scan';
  paddingTopBox: string;
  paddingBottomBox: string;
  // @ts-ignore
  @ViewChild('contactGroup') contactGroup;
  constructor(
    // private translate: TranslateService,
    private customerService: CustomerService,
    private dashboardService: DashboardService,
    private rootService: RootService
  ) {
    // translate.setDefaultLang('vi');
    // test


    this.rootService.scanCurrentMessage
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((base64) => {
        if (base64 !== false) {
          this.bg += 1;
          setTimeout(() => {
            this.bg -= 1;
          }, 3000);

          if (typeof base64 === 'string') {

            this.listRealtime.unshift(JSON.parse(this.b64_to_utf8(base64)));
            console.log(22244, this.listRealtime);

            if (this.listRealtime.length > this.pageSize) {
              this.listRealtime.length = this.pageSize;
            }

            this.listRealtime = this.listRealtime.map((item) => ({...item}));
            console.log(222, this.listRealtime);

            this.$jquery();
          }
        }
      });
    this.rootService.disconnetStatusMessage
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((mes) => {
        if (mes !== 'none') {
          this.disconnectIo = mes;
        }
      });
  }

  ngOnInit() {
    this.changeTab('month');
    const query = {
      page: this.pageIndex,
      page_size: this.pageSize,
    };

    this.dashboardService
      .listAction(query)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res) => {
        console.log('res', res);
        this.listRealtime = res.items !== null ? res.items : [];
        this.$jquery();

      });

    const query2 = {
      page: 1,
      page_size: 5,
    };
    this.customerService
      .list(query2)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res) => {
        this.customers = res.data.items;
      });

    this.dashboardService
      .summary()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res) => {
        this.summary = res.data;
      });

    this.dashboardService
      .listSupcription()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res) => {
        this.listSupcription = res.data;
      });

    // show baner
    if (sessionStorage.getItem('showBanner') !== 'true') {
      this.isVisible = true;
    }
    sessionStorage.setItem('showBanner', 'true');
  }

  handleCancel(): void {
    this.isVisible = false;
  }


  showStatusPhone() {
    this.contactGroup.showModal();
  }

  reloadPage() {
    location.reload();
  }


  /*Char*/
  changeTab(value: string) {
    this.dateRange = [];
    this.tabValue = value;
    if (this.tabValue === 'today') {

      this.startTime = this.formatDate(Date.now()).split(' ')[1];
      this.endTime = this.formatDate(Date.now()).split(' ')[1];
      this.timeLabel = 'hour';
    }

    if (this.tabValue === 'week') {
      const startDayInWeed =
        new Date().getDate() -
        new Date().getDay() +
        (new Date().getDay() === 0 ? -6 : 1);
      this.startTime = this.formatDate(
        new Date(
          new Date(new Date().setDate(startDayInWeed)).setHours(0, 0, 0, 1)
        ).getTime()
      ).split(' ')[1];
      // tslint:disable-next-line:max-line-length
      this.endTime = this.formatDate(
        new Date(
          new Date(new Date().setDate(startDayInWeed + 6)).setHours(
            23,
            59,
            59,
            999
          )
        ).getTime()
      ).split(' ')[1];
      this.timeLabel = 'day';


    }

    if (this.tabValue === 'month') {
      // tslint:disable-next-line:max-line-length
      this.startTime = this.formatDate(
        new Date(
          new Date(new Date().getFullYear(), new Date().getMonth(), 1).setHours(
            0,
            0,
            0,
            1
          )
        ).getTime()
      ).split(' ')[1];
      // tslint:disable-next-line:max-line-length
      this.endTime = this.formatDate(
        new Date(
          new Date(
            new Date().getFullYear(),
            new Date().getMonth() + 1,
            0
          ).setHours(23, 59, 59, 999)
        ).getTime()
      ).split(' ')[1];
      this.timeLabel = 'day';
    }


    setTimeout(() => {
      this.loadChart();
    }, 300);
  }

  actionSelect(event) {
    this.action = event;
    if (event === 'review') {
      this.actionText = 'đánh giá';
    } else if (event === 'question') {
      this.actionText = 'hỏi đáp';
    } else {
      this.actionText = event;
    }

    setTimeout(() => {
      this.loadChart();
    }, 300);
  }

  search() {
    this.loadingChart = true;
    if (this.dateRange.length > 0) {
      this.startTime = this.formatDate(this.dateRange[0].getTime()).split(
        ' '
      )[1];
      this.endTime = this.formatDate(this.dateRange[1].getTime()).split(' ')[1];
      if (this.startTime === this.endTime)

      {
        this.timeLabel = 'hour';
      } else {
        this.timeLabel = 'day';
      }

      setTimeout(() => {
        this.loadChart();
      }, 300);
    } else {
      this.changeTab(this.tabValue);
    }
  }

  clickCustomer(contentName){
    let target = '';
    switch (contentName){
      case 'customer': target = 'portal_customer_list'; break;
      case 'distributor': {
        target = 'portal_distributor_list';
      }; break;
      case 'store': target = 'portal_store_list'; break;
      case 'view_all_history': target = 'portal_interaction'; break;
      case 'view_all_customer': target = 'portal_customer_list'; break;
    }

  }

  loadChart() {
    this.categoryLine = [];
    this.dataTimeLine = [];
    this.dataTimePie = [];
    this.queryChartLine = {
      start_time: this.startTime,
      end_time: this.endTime,
      action_type: this.action,
      time_label: this.timeLabel,
    };

    this.loadingChart = true;
    this.dashboardService
      .charList(this.queryChartLine)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (res) => {
          if (res) {
            res.data.timeStats.map((data) => {
              if (this.timeLabel === 'hour') {
                // tslint:disable-next-line:radix
                const hour =
                  parseInt(data.timeLabel.split(' ')[1].split(':')[0]) + 'h';
                this.categoryLine.push(hour);
              } else {
                const day = data.timeLabel.split(' ')[0].split('-');
                this.categoryLine.push(day[0] + '/' + day[1]);
              }

              this.dataTimeLine.push({y: data.value});
            });
            // tslint:disable-next-line:no-unused-expression
            res.data.provinceStats.map((data) => {
              this.dataTimePie.push([data.provinceName, data.count]);
            });
            this.loadingChart = false;
          }
        },
        (err) => {
          this.highchartsLine();
          this.loadingChart = false;
          this.loadChartPie();
        },
        () => {
          this.highchartsLine();
          this.loadingChart = false;
          this.loadChartPie();
        }
      );
  }

  highchartsLine() {
    Highcharts.chart('chartLine', {
      chart: {
        type: 'area',
      },
      title: {
        align: 'left',
        text: '',
      },
      xAxis: {
        categories: this.categoryLine,
      },

      yAxis: {
        title: {
          text: '',
        },
      },
      // tooltip: {
      //   pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
      // },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: false,
          },
          showInLegend: true,
        },
      },
      series: [
        {
          name: `Số lượng ${this.actionText}`,
          colorByPoint: true,
          data: this.dataTimeLine,
          type: undefined,
        },
      ],
    });
  }

  loadChartPie() {
    Highcharts.chart('pie', {
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        type: 'pie',
      },
      title: {
        text: '',
      },
      tooltip: {
        pointFormat: `Tỉ lệ ${this.actionText}: <b>{point.percentage:.1f}%</b>`,
      },

      series: [
        {
          type: 'pie',
          allowPointSelect: true,
          keys: ['name', 'y', 'selected', 'sliced'],
          data: this.dataTimePie,
          showInLegend: true,
        },
      ],
    });
  }

  formatDate(timestamp) {
    const now = new Date(timestamp);
    const year = '' + now.getFullYear();
    let month = '' + (now.getMonth() + 1);
    if (month.length === 1) {
      month = '0' + month;
    }
    let day = '' + now.getDate();
    if (day.length === 1) {
      day = '0' + day;
    }
    let hour = '' + now.getHours();
    if (hour.length === 1) {
      hour = '0' + hour;
    }
    let minute = '' + now.getMinutes();
    if (minute.length === 1) {
      minute = '0' + minute;
    }
    let second = '' + now.getSeconds();
    if (second.length === 1) {
      second = '0' + second;
    }
    return (
      hour + ':' + minute + ':' + second + ' ' + day + '-' + month + '-' + year
    );
  }

  /*End Char*/

  /*Socket*/
  $jquery() {
    // $(window).on('load', () => {

    setTimeout(() => {
      // tinh toan height phan tu de lay so luong hien thi
      let totalIndex = 0;
      let totalBox = 0;
      const arr = [];
      // console.log(' this.listRealtime',  this.listRealtime)
      const lengthData = this.listRealtime.length > 8 ? 8 : this.listRealtime.length;
      for (let i = 0; i < lengthData; i++) {
        const checkIndex = `.checkIndex${i}`;
        if (totalBox + $(checkIndex).height() < 615) {
          totalBox += $(checkIndex).height();
          totalIndex += 1;
        }

        // console.log(i, $(checkIndex).height(), totalBox, totalIndex);

      }
      if (lengthData >= 5) {
        this.paddingTopBox = ((615 - totalBox) / totalIndex) / 2 + 'px';
        this.paddingBottomBox = ((615 - totalBox) / totalIndex) / 2 + 'px';
      } else {
        this.paddingTopBox = '10px';
        this.paddingBottomBox = '10px';
      }

      this.listRealtime.length = totalIndex;

      // tinh toan hien thi nut Scan
      for (let i = 0; i < lengthData; i++) {
        const className = `.mydiv${i}`;
        arr.push($(className).width());
      }

      const status = $('.setBoxRealtimeLeft').width() - (82 + Math.max(...arr));
      $('.setBoxRealtimeProduct').css('width', Math.max(...arr));
      $('.setBoxRealtimeContent').css('width', status);
      $('.setBoxRealtimeContent').css('opacity', 1);

      this.loading = false;

    }, 1000);

  }



  b64_to_utf8(str) {
    return decodeURIComponent(escape(window.atob(str)));
  }



  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
